<template>
  <div>
    <div v-if="model">
      <div class="main-content">
        <div class="main-content-heading">
          <h1>Dotazník štýlov riešenia problémov</h1>
          <div class="back">
            <router-link :to="{name: 'questionary_all'}">&lt; Späť na dotazníky</router-link>
          </div>
        </div>
        <div class="heading-spliter"></div>
        <div class="text-mute">
          Spolupráca a komunikácia pri riešení problémov si vyžaduje od nás rôzne správanie. Niekto sa správa tak, ako sa od neho požaduje a očakáva, pre niekoho to môže byť ťažké. 
          <br><br>
          <b>Inštrukcia</b>
          <br><br>
           Prečítajte si nižšie párové charakteristiky. Pri každej dvojici sa rozhodnite, s ktorým výrokom viac súhlasíte a podľa toho nastavte bod na škále. Čím viac vľavo, tým viac vás vystihuje výrok vľavo. Čím viac nastavíte bod vpravo, tým viac vás vystihuje výrok vpravo. Využívajte celý rozsah škály a neobmedzujte sa na extrémy alebo stred. 
          <br><br>
          Nad umiestnením nerozmýšľajte dlho – prvá reakcia vás vystihuje najlepšie.
        </div>
        <h2>{{model.questionary.lang.name}}</h2>
        <div class="main-content-box result" v-if="model.result && !model.questionary.hidden_results">
          <div class="left">Váš výsledok</div>
          <div class="right">
            <div class="finished">
              <div class="item">DPS: {{model.result.dps}}</div>
              <div class="item">SO: {{model.result.so}}</div>
              <div class="item">V: {{model.result.v}}</div>
              <div class="item">Spolu: {{model.result.total}}</div>
              <div class="item hide_mobile_flex">
                <a
                  style="color: inherit; text-transform: none;"
                  target="_blank"
                  :href="pdfUrl+'/api/public/questionary/pdf?arr='+model.pdf"
                >
                  <img style="width: 14px;" src="/static/download.svg" />&nbsp; Stiahnúť report
                </a>
              </div>
            </div>
            <div class="finished show_mobile_flex">
              <a
                style="color: inherit; text-transform: none;"
                target="_blank"
                :href="pdfUrl+'/api/public/questionary/pdf?arr='+model.pdf"
              >
                <img style="width: 14px;" src="/static/download.svg" />&nbsp; Stiahnúť report
              </a>
            </div>
          </div>
        </div>
        <div v-for="question in questionModel" class="main-content-box kai">
          <div class="left">{{question.question.left}}</div>
          <div :class="['center' , question.model !== null ? '' : 'disabled']">
            <range-slider
              class="slider"
              min="0"
              max="100"
              step="0.001"
              v-model="question.model"
              :disabled="!!model.result"
              @change="saveQuestion(question)"
              @input="changeVal(question,$event)"
            ></range-slider>
          </div>
          <div class="right">{{question.question.right}}</div>
        </div>
        <div class="bottom-buttons">
          <a v-if="!model.result" @click="close" class="button">Odoslať dotazník ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormBase from "../../elements/FormBase";
import { required, email } from "vuelidate/lib/validators";
import RangeSlider from "vue-range-slider";
import Vue from "vue";
import _ from "lodash";
import server from "../../api/server";
export default {
  components: {
    RangeSlider
  },
  mixins: [FormBase],
  props: ["model"],
  data() {
    return {
      questionModel: null,
      pdfUrl: server.baseUrl,
      savedQuestions: [],
      timeout: null
    };
  },
  mounted() {},
  created() {
    this.timeout = setInterval(() => {
      this.save();
    }, 2500);
  },
  destroyed() {
    clearInterval(this.timeout);
  },
  methods: {
    changeVal(question, e) {
      this.$forceUpdate();
    },
    saveQuestion(question) {
      if(question.model === null){
        question.model = 50;
      }
      this.$forceUpdate();
      this.savedQuestions.push({
        id: this.model.id,
        lang_id: this.$api.translator.getCurrent(),
        local_id: question.question.local_id,
        value: Math.round(question.model)
      });
    },
    save() {
      if (this.savedQuestions.length > 0) {
        this.$forceUpdate();
        let q = this.savedQuestions;
        this.savedQuestions = [];
        this.$api.server
          .post("api/public/questionary/questions/save_all", {
            arr: JSON.stringify(q)
          })
          .then(r => {
            this.$api.bus.trigger(
              "course-status-change",
              this.model.id,
              r.data.progress
            );
          })
          .catch(() => {
            alert("Chyba pri ukladaní dát. Obnovte stránku prosím.");
          });
      }
    },
    check() {
      for (var i in this.questionModel) {
        if (this.questionModel[i].model === null) {
          return false;
        }
      }
      return true;
    },
    close() {
      var self = this;
      if (!this.check()) {
        self.$api.toaster.fail({ txt: "Vyplnte všetky polia" });
        return;
      }
      this.save();
      this.$api.bus.trigger("open-modal", {
        header: "Odoslať dotazník na hodnotenie ?",
        message: "Odoslať dotazník na hodnotenie ?",
        okBtn: "Áno",
        closeBtn: "Nie",
        cb() {
          self.$api.server
            .post("api/public/questionary/questions/close", {
              id: self.model.id,
              lang_id: self.$api.translator.getCurrent()
            })
            .then(r => {
              if (r.data.result) {
                window.location.reload();
              } else {
                self.$api.toaster.fail({
                  txt: "Chyba pri odosielaní formuláru. Skúste to znovu."
                });
              }
            });
        }
      });
    }
  },
  computed: {},
  watch: {
    model: {
      handler() {
        if (!this.model) return;
        this.questionModel = [];
        var self = this;
        for (var i in this.model.questions) {
          //this.model.questions[i] = new Vue({data:()=>{return {...self.model.questions[i]};}});
          this.questionModel[i] = new Vue({
            data: () => {
              return { ...self.model.questions[i] };
            }
          });
          this.questionModel[i].model = this.model.questions[i].result
            ? this.model.questions[i].result.value
            : null;
        }
      },
      immediate: true,
      deep: false
    }
  },
  validations() {}
};
</script>
<style lang="css">
.center .range-slider {
  width: 90%;
}
.center {
  text-align: center;
}

a {
  cursor: pointer;
}
.center.disabled .range-slider-fill {
  width: 0px !important;
}
main .content .main-content .main-content-box.kai .left, main .content .main-content .main-content-box.kai .right{
  width: 230px !important;
}
</style>



// WEBPACK FOOTER //
// src/public_app/pages/questionary/KaiForm.vue